import { Helmet } from "react-helmet";
import Header from "../../../../../Components/Header";
import Salesform from "./Salesform";


const Create = () => {
  return (
    <div className='d-flex flex-column' style={{ minHeight: '100vh' }}>
      <Helmet>
				  <title>Sales Order - Create</title>
			  </Helmet>
      <Header />
      <div className="container-fluid maindiv d-flex flex-column " style={{flexGrow:'1'}}>
        <Salesform/>
      </div>
    </div>
  );
};

export default Create;
